import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-4">
      <div className="container mx-auto text-center">
        <p className="text-sm">
          &copy; 2026 Hayden Home Services LLC. <br></br> Olathe, KS
          66062<br></br>{" "}
          Insured Contractor & Handyman Services.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
